import  { useEffect, useState }  from 'react';
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Icon } from './../common/icons'
import Aux from './../hoc/auxiliary';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  headers: {'Access-Control-Allow-Origin': '*'}
  
};

export default function DocumentViewer(props){
  const [numPages, setNumPages] = useState(null);

  const { file, showWatermark, isFilePreview  } = props;


function onDocumentLoadSuccess({ numPages }) {
  setNumPages(numPages);


} 

const [isFScreen, setFullScreen] = useState(false);

useEffect(() => {
  function handleFullScreenChange() {
    if (document.fullscreenElement) {
      setFullScreen(true);
    } else {
      setFullScreen(false);
    }
  }

  document.addEventListener('fullscreenchange', handleFullScreenChange);

  return () => {
    document.removeEventListener('fullscreenchange', handleFullScreenChange);
  };
}, []);

useEffect(() => {
  function handleEscKeyPress(event) {
    if (event.key === 'Escape') {
      exitFullScreen();
    }
  }

  if (isFScreen) {
    window.addEventListener('keydown', handleEscKeyPress);
  } else {
    window.removeEventListener('keydown', handleEscKeyPress);
  }

  return () => {
    window.removeEventListener('keydown', handleEscKeyPress);
  };
}, [isFScreen]);

const enterFullScreen = () => {
  if (document.getElementById("document")?.requestFullscreen) {
    document.getElementById("document")?.requestFullscreen();
  }
};

const exitFullScreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  }
};

  return (
        <Aux>
           {!isFScreen
            &&
             
              <button className="btn pdf__enlarge btn pdf__minimise ai-body-tiny ai-grey-100" style={{alignSelf: 'flex-end'}} onClick={(e) => enterFullScreen(e)}>
              <Icon name="enlarge" customClass="icon--normal" />
              {/* <div className="btn__popover">Full screen</div> */}
            </button>
            }
              
             
              <div style={isFilePreview ? {minHeight: '60vh', maxHeight: '80vh', overflowY: 'auto', overflowX: 'hidden', position: 'relative'} : {maxHeight: '100%', overflowY: 'auto', overflowX: 'hidden', position: 'relative'}}>
            <div   id="document" style={isFScreen ? {maxHeight: '100%', overflowY: 'auto', overFlowX: 'hidden', position: 'relative'} : {maxHeight: '100%',  position: 'relative'}}>
              {isFScreen && 
               <button className="btn pdf__minimise ai-body-tiny ai-grey-100" style={{position: 'fixed', right: '4rem', top: '4rem', zIndex: 2}} onClick={(e) => exitFullScreen(e)}>
               <Icon name="shrink" customClass="icon--normal" />
               {/* <div className="btn__popover">Exit full screen</div> */}
             </button>}
      {file &&
    <Document file={file}    onLoadSuccess={onDocumentLoadSuccess} options={options}>
       {showWatermark && <div className="pdf__watermark"></div>}
        {Array.from(
        new Array(numPages),
        (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              scale={2}
              
              
            />
        ),
      )}
          </Document>
      }
         </div>
         </div>
      </Aux>
 
  );
};

